import { Badge } from '@amzn/awsui-components-core';
import { ContentAudience } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { contentAudienceBadgeDisplayNames } from '../utils/DisplayNames';

class ContentAudienceBadge extends React.Component<{ contentAudience: ContentAudience }> {
  private static displayConfig = new Map<
    ContentAudience,
    { color: 'blue' | 'grey' | 'green' | 'red'; displayName: string }
    // @ts-expect-error TS2769 - strict migration
  >([
    [
      ContentAudience.PUBLIC,
      { color: 'green', displayName: contentAudienceBadgeDisplayNames.get(ContentAudience.PUBLIC) },
    ],
    [
      ContentAudience.EXTERNAL,
      {
        color: 'grey',
        displayName: contentAudienceBadgeDisplayNames.get(ContentAudience.EXTERNAL),
      },
    ],
    [
      ContentAudience.INTERNAL,
      {
        color: 'grey',
        displayName: contentAudienceBadgeDisplayNames.get(ContentAudience.INTERNAL),
      },
    ],
  ]);
  render() {
    const { contentAudience } = this.props;

    if (!ContentAudience) {
      return null;
    }

    const config = ContentAudienceBadge.displayConfig.get(contentAudience) || {
      color: 'grey',
      displayName: 'Unknown',
    };
    return <Badge color={config.color} children={config.displayName} />;
  }
}

export default ContentAudienceBadge;
